module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (260).91e3b24d.jpg";